import { takeArgumentProp } from "./fpUtils";
import { createActionBuilders } from "./reduxUtils/createActionBuilders/createActionBuilders";

const template = require("lodash/template");

const takeKey = takeArgumentProp("key");

/**
 * @deprecated Use {@link createActionBuilders} instead.
 */
export function constObjectGenerator<T extends string, U = { [K in T]: K }>(
    keys: T[],
    format?: string
): U {
    const hasFormat = format?.length > 3 && format.includes("{key}");
    const buildKey = hasFormat ? template(format) : takeKey;

    const obj = {} as U;
    for (let key of keys) {
        // @ts-ignore
        obj[key] = buildKey({ key });
    }

    return Object.freeze(obj);
}
